import { render, staticRenderFns } from "./pagesAdd.vue?vue&type=template&id=314e934e&scoped=true"
import script from "./pagesAdd.vue?vue&type=script&lang=js"
export * from "./pagesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314e934e",
  null
  
)

export default component.exports